import { ImageFit, Image, mergeStyleSets, Icon } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";

const classNames = mergeStyleSets({
  itemImage: {
    flexShrink: 0,
  },
  placeHolder: {
    backgroundColor: "gray",
    color: "white",
    fontSize: 40,
    textAlign: "center",
  },
});

interface Props {
  src: string;
  width?: string | number;
  height?: string | number;
}

const ImagePlaceholder: FunctionComponent<Props> = (props: Props) => {
  const { src, width, height } = props;

  return (
    <>
      {src && (
        <Image
          className={classNames.itemImage}
          src={src}
          width={width ?? 50}
          height={height ?? 50}
          imageFit={ImageFit.cover}
        />
      )}
      {!src && (
        <div className={classNames.placeHolder} style={{ width, height }}>
          <Icon iconName="Door"></Icon>
        </div>
      )}
    </>
  );
};

export default ImagePlaceholder;
